export type NotificationTone = 'info' | 'success' | 'warning' | 'danger' | 'muted';

export function typeToTone(type: string): NotificationTone {
  if (type === 'InvoicePaid') return 'success';
  if (type === 'ReminderFailed') return 'danger';
  if (type === 'AppointmentRequested' || type === 'AppointmentRescheduleRequested') return 'info';
  if (type === 'AppointmentCancelled' || type === 'PatientProfileRejected') return 'warning';
  return 'muted';
}

export function getNotificationRelativeTime(createdAt: Date, now = new Date()): { key: string; count?: number } {
  const minutes = Math.max(0, Math.floor((now.getTime() - createdAt.getTime()) / 60_000));
  if (minutes < 1) return { key: 'time.justNow' };
  if (minutes < 60) return { key: 'time.minutesAgo', count: minutes };
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return { key: 'time.hoursAgo', count: hours };
  return { key: 'time.daysAgo', count: Math.floor(hours / 24) };
}
